import { ConsumerSessionState } from './consumer-session-state.interface'

export const createConsumerSessionState = (): ConsumerSessionState => ({
  sessionToken: null,
  fetchingConsumerSession: false,
  getSessionTokenError: null,
  error: null,
})
